import { useCallback } from 'react';
import { CommercialReimbursement, ReimbursementType } from 'types/underwriting/income-approach';
import DollarAmountReimbursementTable from './tables/DollarAmountReimbursementTable';
import Form, { Field } from 'mobx-react-form';
import PercentOfExpenseForecastReimbursementTable from './tables/PercentOfExpenseForecastReimbursementTable';
import PercentOfCurrentTaxYearLiabilityReimbursementTable from './tables/PercentOfCurrentTaxYearLiabilityReimbursementTable';

type CommercialReimbursementContainerProps = {
  form: Form;
  reimbursementFieldPath: string;
};

const CommercialReimbursementContainer: React.FC<CommercialReimbursementContainerProps> = ({
  form,
  reimbursementFieldPath,
}) => {
  const reimbursementField: Field = form.$(reimbursementFieldPath);
  const onEditReimbursementModalSave = useCallback(
    (reimbursement: CommercialReimbursement) => {
      reimbursementField.clear(true);
      reimbursementField.reset(true);
      reimbursementField.update(reimbursement);
    },
    [reimbursementField]
  );

  const onReimbursementDeleted = useCallback(() => {
    form.del(reimbursementFieldPath);
  }, [form, reimbursementFieldPath]);

  switch (reimbursementField.value.reimbursementType as ReimbursementType) {
    case 'dollarAmount':
      return (
        <DollarAmountReimbursementTable
          reimbursementField={reimbursementField}
          onUpdate={onEditReimbursementModalSave}
          onDelete={onReimbursementDeleted}
        />
      );
    case 'percentOfForecast':
      return (
        <PercentOfExpenseForecastReimbursementTable
          reimbursementField={reimbursementField}
          onUpdate={onEditReimbursementModalSave}
          onDelete={onReimbursementDeleted}
        />
      );
    case 'percentOfCurrentYearLiability':
      return (
        <PercentOfCurrentTaxYearLiabilityReimbursementTable
          reimbursementField={reimbursementField}
          onUpdate={onEditReimbursementModalSave}
          onDelete={onReimbursementDeleted}
        />
      );
    default:
      return null;
  }
};

export default CommercialReimbursementContainer;
